var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1931_3957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.72215 4.05816L6.7227 4.30705L5.47437 2.7515C5.41971 2.68337 5.35045 2.62838 5.2717 2.5906C5.19295 2.55282 5.10672 2.5332 5.01937 2.5332C4.93203 2.5332 4.84579 2.55282 4.76704 2.5906C4.68829 2.62838 4.61903 2.68337 4.56437 2.7515L3.31604 4.30705L2.29715 4.05816C2.1995 4.03479 2.0975 4.03685 2.00087 4.06414C1.90425 4.09143 1.81623 4.14303 1.74524 4.21403C1.67424 4.28503 1.62263 4.37304 1.59535 4.46966C1.56806 4.56629 1.566 4.6683 1.58937 4.76594L2.2777 7.18483C2.30123 7.26895 2.35238 7.3427 2.42293 7.3942C2.49348 7.4457 2.57931 7.47195 2.66659 7.46872H7.33326C7.42054 7.47195 7.50637 7.4457 7.57692 7.3942C7.64747 7.3427 7.69863 7.26895 7.72215 7.18483L8.41437 4.76594C8.43672 4.66985 8.43449 4.56967 8.4079 4.47467C8.38131 4.37966 8.33121 4.29288 8.26223 4.22235C8.19324 4.15182 8.1076 4.0998 8.01321 4.07111C7.91882 4.04241 7.81872 4.03796 7.72215 4.05816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40262 3.63824C1.67109 3.63824 1.88873 3.4206 1.88873 3.15213C1.88873 2.88365 1.67109 2.66602 1.40262 2.66602C1.13414 2.66602 0.916504 2.88365 0.916504 3.15213C0.916504 3.4206 1.13414 3.63824 1.40262 3.63824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59695 3.63824C8.86542 3.63824 9.08306 3.4206 9.08306 3.15213C9.08306 2.88365 8.86542 2.66602 8.59695 2.66602C8.32848 2.66602 8.11084 2.88365 8.11084 3.15213C8.11084 3.4206 8.32848 3.63824 8.59695 3.63824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99978 1.98589C5.26825 1.98589 5.48589 1.76825 5.48589 1.49978C5.48589 1.23131 5.26825 1.01367 4.99978 1.01367C4.73131 1.01367 4.51367 1.23131 4.51367 1.49978C4.51367 1.76825 4.73131 1.98589 4.99978 1.98589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33314 8.88911H2.66648C2.56334 8.88911 2.46442 8.84813 2.39149 8.7752C2.31856 8.70227 2.27759 8.60336 2.27759 8.50022C2.27759 8.39708 2.31856 8.29816 2.39149 8.22523C2.46442 8.1523 2.56334 8.11133 2.66648 8.11133H7.33314C7.43628 8.11133 7.5352 8.1523 7.60813 8.22523C7.68106 8.29816 7.72203 8.39708 7.72203 8.50022C7.72203 8.60336 7.68106 8.70227 7.60813 8.7752C7.5352 8.84813 7.43628 8.88911 7.33314 8.88911Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1931_3957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "translate(0.333252 0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCrown);
export default __webpack_public_path__ + "static/media/whiteCrown.8afe06ab76f08f3db157300b30fe7c22.svg";
export { ForwardRef as ReactComponent };